<template>
    <b-sidebar
        v-model="localVisible"
        no-header
        backdrop
        sidebar-class="b-sidebar-bottom"
        @hidden="closeSidebar()"
    >
        <b-card class="border-0">
            <b-card-header class="bg-transparent p-2 border-0">
                <div
                    class="d-flex flex-column justify-content-center align-items-center">
                    <h2 class="mb-0">เพิ่มรายการใช้จ่าย</h2>
                    <h5>ระบุรายละเอียดและจำนวนเงินค่าใช้จ่าย</h5>
                </div>
                <div>
                    <hr class="my-3" />
                </div>
            </b-card-header>
            <b-card-body class="p-2">
                <ValidationObserver ref="observer">
                    <b-form @submit="onSubmit">
                        <b-row>
                            <b-col lg="12">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <b-form-group label="รายละเอียด" label-for="input-details">
                                        <b-form-input 
                                            id="input-details" 
                                            placeholder="ระบุรายละเอียด" 
                                            v-model="form.name"
                                            :state="!errors.length ? null : false"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="12">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <b-form-group label="จำนวนเงิน (บาท)" label-for="input-total">
                                        <b-form-input 
                                            type="number" 
                                            id="input-total"
                                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                            placeholder="ระบุจำนวนเงิน" 
                                            v-model="form.price"
                                            :state="!errors.length ? null : false"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="12">
                                <b-button
                                    variant="primary"
                                    block
                                    type="submit"
                                >
                                    ยืนยัน
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </ValidationObserver>
            </b-card-body>
        </b-card>
    </b-sidebar>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { modalSuccess, modalError } from '@/util/alert.js'
import jobServices from "@/api/job.service.js";

export default {
    props: {
        isVisible: {
            type: Boolean
        }
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data(){
        return{
            form: {
                name: null,
                price: null
            },
            localVisible: this.isVisible
        }
    },
    methods: {
        async onSubmit(event){
            event.preventDefault();
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            try{
                const { data } = await jobServices.createJobExpenses({
                    job_id: Number(this.$route.params.id),
                    name: this.form.name,
                    price: Number(this.form.price),
                });

                if(data){
                    modalSuccess(this.$bvModal, "เพิ่มรายการใช้จ่ายสำเร็จ")
                    this.$emit('getExpenses')
                    this.closeSidebar();
                }
            }catch(err){

            }
        },
        closeSidebar(){
            this.$refs.observer.reset();
            this.localVisible = false;
            this.$emit('update:isVisible', false)
            this.form = {
                name: null,
                price: null
            }
        }
    },
    watch: {
        isVisible(newVal) {
            this.localVisible = newVal;
        }
    },
}
</script>
